import { onUnmounted, onMounted, ref } from 'vue'
import { useFetch } from '@/features/fetch'

const POLL_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes
const VERSION_URL = '/version.json'

const fetchCurrentVersion = async (): Promise<string | null> => {
  const fetch = useFetch('base')
  try {
    const res = await fetch(`${VERSION_URL}?t=${Date.now()}`) // déactive le cache
    if (!res.ok) {
      console.error('Failed to fetch version', res.statusText)
      return null
    }
    const { version } = (await res.json()) as { version: string }
    return version
  } catch (err) {
    console.error('Failed to fetch version', err)
    return null
  }
}

export const useVersionWatcher = () => {
  const updateAvailable = ref(false)
  let initialVersion: string | null = null
  let intervalId: ReturnType<typeof setInterval> | null = null

  const start = async () => {
    initialVersion = await fetchCurrentVersion()
    intervalId = setInterval(async () => {
      const latestVersion = await fetchCurrentVersion()
      if (!latestVersion) return
      if (!initialVersion) initialVersion = latestVersion
      if (latestVersion !== initialVersion) {
        updateAvailable.value = true
        stop()
      }
    }, POLL_INTERVAL_MS)
  }

  const stop = () => {
    if (intervalId)
      clearInterval(intervalId)
  }

  onMounted(start)
  onUnmounted(stop)

  return { updateAvailable }
}
